import { mapGetters } from 'vuex'
import router from '@/router'

export default {
  computed: {
    ...mapGetters({
      'search/dateRange': 'search/dateRange'
    }),
    isDateSelected: function () {
      return router.currentRoute.query.start && router.currentRoute.query.end
    },
    dateRangeFormate: function () {
      const start = router.currentRoute?.query?.start && router.currentRoute?.query?.end ? this.$options.filters.toDate(router.currentRoute?.query?.start, 'YYYY/MM/DD ddd') : this.$t('datePicker.placeHolder.startDate')
      const end = router.currentRoute?.query?.start && router.currentRoute?.query?.end ? this.$options.filters.toDate(router.currentRoute?.query?.end, 'YYYY/MM/DD ddd') : this.$t('datePicker.placeHolder.endDate')
      return `${start} ~ ${end}`
    }
  }
}
